import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { provideTranslationStatic } from '@skyeng/libs/shared/i18n';
import { DsIconModule } from '@skyeng/libs/shared/ui-kit-v2/icon';

import deTranslation from '../report-chat-panel/translation/de.json';
import enTranslation from '../report-chat-panel/translation/en.json';
import esTranslation from '../report-chat-panel/translation/es.json';
import frTranslation from '../report-chat-panel/translation/fr.json';
import itTranslation from '../report-chat-panel/translation/it.json';
import jaTranslation from '../report-chat-panel/translation/ja.json';
import koTranslation from '../report-chat-panel/translation/ko.json';
import plTranslation from '../report-chat-panel/translation/pl.json';
import ptTranslation from '../report-chat-panel/translation/pt.json';
import ruTranslation from '../report-chat-panel/translation/ru.json';
import ukTranslation from '../report-chat-panel/translation/uk.json';
import { LABORATORY_REPORT_CHAT_PANEL_TRANSLATION_SCHEME } from '../report-chat-panel/translation/translation-schema';

/**
 * The support-chat header row from the «Чат поддержки» frames: title +
 * square history/close icon buttons with the unread dot. Shared by the
 * standalone panel and the error-report dialog so the chrome exists once.
 */
@Component({
  selector: 'laboratory-report-chat-panel-header',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoModule, DsIconModule],
  templateUrl: './report-chat-panel-header.component.html',
  styleUrls: ['./report-chat-panel-header.component.scss'],
  viewProviders: [
    provideTranslationStatic(LABORATORY_REPORT_CHAT_PANEL_TRANSLATION_SCHEME.tsScope, {
      de: deTranslation,
      en: enTranslation,
      es: esTranslation,
      fr: frTranslation,
      it: itTranslation,
      ja: jaTranslation,
      ko: koTranslation,
      pl: plTranslation,
      pt: ptTranslation,
      ru: ruTranslation,
      uk: ukTranslation,
    }),
  ],
})
export class ReportChatPanelHeaderComponent {
  readonly ts = LABORATORY_REPORT_CHAT_PANEL_TRANSLATION_SCHEME;

  /** Header title; defaults to the localized «Поддержка» (supportTitle). */
  readonly title = input('');
  /** Renders the history square icon button. */
  readonly showHistoryButton = input(false);
  /** Red dot on the history button — a new message in another обращение. */
  readonly hasUnread = input(false);
  /** Accessible labels for the icon buttons; localized defaults apply. */
  readonly historyAriaLabel = input('');
  readonly closeAriaLabel = input('');

  readonly historyClick = output<void>();
  readonly closeClick = output<void>();
}
